import VersionCard from './VersionCard';
import VersionCardSkeleton from './VersionCardSkeleton';
import useClipVersions from '@/hooks/useClipVersions';
import IconButton from '@/components/atoms/Button/IconButton';

interface ClipCustomizerVersioningPanelProps {
  onClose: () => void;
}

export default function ClipCustomizerVersioningPanel({ onClose }: ClipCustomizerVersioningPanelProps) {
  const { versions, isLoadingVersions, viewingVersion, restoringVersion, handleView, handleRestore } =
    useClipVersions();

  const isRestoring = restoringVersion !== null;

  return (
    <div className="flex h-[calc(100vh-84px)] w-[402px] flex-col overflow-hidden rounded-2xl border bg-white shadow">
      <div className="shrink-0 border-b border-slate-200 p-4">
        <div className="flex items-start gap-1">
          <p className="flex-1 text-base font-medium leading-6 text-slate-950">Version History</p>
          <IconButton
            icon="IconX"
            trackingId="versioning-panel-close"
            disabled={isRestoring}
            onClick={onClose}
            variation="none"
            title="Close Version History"
            buttonClassName="size-6 rounded-md flex items-center justify-center text-slate-900 hover:bg-slate-100 p-0"
          />
        </div>
        <p className="mt-1 text-sm leading-5 text-gray-500">
          {isLoadingVersions ? (
            <span className="inline-block h-3 w-28 animate-pulse rounded bg-slate-200 align-middle" />
          ) : (
            <>
              {versions.length} version{versions.length === 1 ? '' : 's'} saved
            </>
          )}
        </p>
      </div>

      {/* Version list */}
      <div className="flex flex-1 flex-col gap-2 overflow-y-auto px-2 py-3">
        {isLoadingVersions ? (
          <VersionCardSkeleton />
        ) : (
          versions.map((version, index) => (
            <VersionCard
              key={version.id}
              version={version}
              // The list is newest first, so the head is the version the clip is on.
              isCurrentVersion={index === 0}
              isViewingVersion={viewingVersion?.id === version.id}
              isRestoring={restoringVersion?.id === version.id}
              isDimmed={isRestoring && restoringVersion?.id !== version.id}
              onView={handleView}
              onRestore={handleRestore}
            />
          ))
        )}
      </div>
    </div>
  );
}
